module.exports = __webpack_public_path__ + "07680754702abc4e1b47905a0d182ef1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-22.png
// module id = 3079
// module chunks = 0